<div
  class="z-50"
  [ngClass]="{
    sticky: positionSticky,
  }"
  [style.top]="positionSticky ? positionStickyTop + 'px' : ''"
  [style.backgroundColor]="backgroundColor | contentBuilderColor: 'bg-white'"
>
  <div class="flex overflow-x-auto scrollbar-hide pt-4 lg:pt-6 pb-4 lg:pb-6 px-5 lg:px-12">
    <app-block-list [blockIdList]="slides"></app-block-list>
  </div>
</div>
